import { render, staticRenderFns } from "./AddContactUs.vue?vue&type=template&id=2965e5ae&scoped=true&"
import script from "./AddContactUs.vue?vue&type=script&lang=js&"
export * from "./AddContactUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2965e5ae",
  null
  
)

export default component.exports